import {
  DeleteOutlined,
  CloseCircleOutlined,
  EnterOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  StopOutlined,
  EnvironmentFilled,
  StarTwoTone,
  PlayCircleFilled,
  StopFilled,
  SearchOutlined,
  UserOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  Row,
  Select,
  Space,
  Switch,
  Alert,
  Table,
  Tabs,
} from "antd";
import { DateTime } from "luxon";
import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { ActionDateType, OperatorPosition } from "../../enums/equipe.enum";
import styles from "../../index.style";
import { sharedInternalInfoState } from "../../recoil/atoms/sharedInternalAtom";
import CookieService from "../../services/cookie.service";
import EquipeService from "../../services/equipe.service";
import EquipmentService from "../../services/equipe.service";
import { EquipeUser, EquipeUserPayload } from "../../types/equipe.type";
import { User, UserRoleResponse } from "../../types/login.types";
// import "./Equipe.css";
import TimePicker from "../../components/TimePicker/TimePicker";
import { userInfoState } from "../../recoil/atoms/userInfoAtom";
import { useTranslation } from "react-i18next";
import { changeShowLoading } from "../../components/Spinner/Spinner";

const { Panel } = Collapse;

function Equipe() {
  const { t, i18n } = useTranslation();
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const [userRoles, setUserRoles] = useState({} as UserRoleResponse);
  let [equipeList, setEquipeList] = useState([] as EquipeUser[]);
  let [shouldSaveData, setShouldSaveData] = useState(false);
  const [sharedInfo] = useRecoilState(sharedInternalInfoState);
  const [selectedRole, setSelectedRole] = useState("");
  const [positionList, setPositionList] = useState(
    Array<{ key: string; description: string }>() as Array<{
      key: string;
      description: string;
    }>
  );
  const [enableExit, setEnableExit] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");

  const isDisabled = currentStatus === "validated";

  const [rowFE, setRowFE] = useState(0);
  const loadOperators = async (showOnlySurgeryRoomBlock: boolean = false) => {
    let surgeryRoomBlockUUID = null;
    if (showOnlySurgeryRoomBlock) {
      surgeryRoomBlockUUID = CookieService.getSurgeryRoomBlocksUUID();
    }

    changeShowLoading(
      EquipmentService.retrieveUserInRole(surgeryRoomBlockUUID)
        .then((response) => {
          console.log(response);
          setUserRoles(response);
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const initData = async () => {
    changeShowLoading(
      EquipeService.loadData({
        uuid: sharedInfo.surgery,
        tabName: "operators-tab",
      }).then((resp) => {
        setEquipeList(resp?.operator);
        setCurrentStatus(resp?.currentStatus || "");
      })
    );
  };


  const onSelectedUserChanged = (user: User | null | undefined) => {
    if (!user) {
      return;
    }
    const equipe: EquipeUser = {
      uuid: user.operatoruuid,
      user: user,
      operatorPosition: OperatorPosition.FIRST,
      index: equipeList.length,
      inDate: null,
      outDate: null,
      row: `${rowFE}`,
      operatorType: user.operatorTypeuuid,
      description: user.operatorDescription,
      operatorDescription: user.operatorDescription,
      operatorTypeInfo: {
        active: true,
        code: user.operatorTypeCode,
        description: user.operatorTypeDescription,
        notes: null,
        validityEnd: null,
      },
    };

    setRowFE(rowFE + 1);
    equipeList.push(equipe);
    equipeList = [...equipeList];
    setEquipeList(equipeList);
    setShouldSaveData(true);
  };

  const setTeporalMarker = (
    event: DateTime | null,
    userEquipe: EquipeUser,
    type: string
  ) => {
    const now = event?.toFormat("yyyy-MM-dd HH:mm:ss");
    const findOperatorIndex = equipeList.findIndex(
      (el) => el.row === userEquipe.row
    );
    if (type === "in") {
      equipeList[findOperatorIndex] = {
        ...userEquipe,
        inDate: now ? now : null,
      };
    } else {
      equipeList[findOperatorIndex] = {
        ...userEquipe,
        outDate: now ? now : null,
      };
    }

    equipeList = [...equipeList];
    setEquipeList(equipeList);
    setShouldSaveData(true);
  };

  const saveData = () => {
    const payload: EquipeUserPayload[] = equipeList.map((userEquipe) => {
      return {
        operator: userEquipe.uuid,
        operatorPosition: userEquipe.operatorPosition,
        inDate: userEquipe.inDate,
        outDate: userEquipe.outDate,
        operatorType: userEquipe.operatorType,
      };
    });

    if (
      userInfo.capabilities["CAN_EDIT_ALL_TAB"] ||
      userInfo.capabilities["CAN_EDIT_OPERATORS_TAB"]
    ) {
      changeShowLoading(
        EquipeService.update(sharedInfo.surgery, {
          tabName: "operators-tab",
          content: payload,
        })
          .catch((error) => {
            console.error(`${t("ERROR_WHILE_SAVE_DATA")} ${error}`);
          })
          .finally(() => {
            setShouldSaveData(false);
          })
      );
    } else {
      <Alert
        message={t("PERMISSION_NEGATE")}
        type="warning"
        showIcon
        closable
      />;
    }
  };

  const deleteEquipeUser = (userEquipe: EquipeUser) => {
    equipeList = equipeList.filter((u) => u.row !== userEquipe.row);
    setEquipeList(equipeList);
    setShouldSaveData(true);
  };

  const initPositionList = () => {
    // foreach item of OperatorPosition enum, push the value in positionList
    for (let item in OperatorPosition) {
      positionList.push({
        key: OperatorPosition[item as keyof typeof OperatorPosition],
        description: translatePosition(item), //TODO translate
      });
    }
    setPositionList(positionList);
  };

  const translatePosition = (item: string) => {
    let translate = "";
    switch (item) {
      case "FIRST":
        translate = `${t("FIRST")}`;
        break;
      case "SECOND":
        translate = `${t("SECOND")}`;
        break;
      case "THIRD":
        translate = `${t("THIRD")}`;
        break;
      case "FOURTH":
        translate = `${t("FOURTH")}`;
        break;
      case "FIFTH":
        translate = `${t("FIFTH")}`;
        break;
      case "SIXTH":
        translate = `${t("SIXTH")}`;
        break;
      case "SEVENTH":
        translate = `${t("SEVENTH")}`;
        break;
      case "EIGTHTH":
        translate = `${t("EIGTHTH")}`;
        break;
      case "NINTH":
        translate = `${t("NINTH")}`;
        break;
      case "TENTH":
        translate = `${t("TENTH")}`;
        break;
    }
    return translate;
  };

  const changePosition = (
    value: any,
    userEquipe: EquipeUser,
    index: number
  ) => {
    equipeList[index] = {
      ...userEquipe,
      operatorPosition: value,
    };
    setEquipeList(equipeList);
    setShouldSaveData(true);
  };

  const applyMassiveDate = (type: ActionDateType) => {
    const now = DateTime.local().toFormat("yyyy-MM-dd HH:mm:ss");

    equipeList = equipeList.map((userEquipe) => {
      if (type === ActionDateType.IN) {
        userEquipe.inDate = userEquipe.inDate ? userEquipe.inDate : now;
      } else if (type === ActionDateType.OUT && userEquipe.inDate) {
        userEquipe.outDate = userEquipe.outDate ? userEquipe.outDate : now;
      }
      return userEquipe;
    });

    setEquipeList(equipeList);
    setShouldSaveData(true);
  };

  const loadOffBlockUser = (showOnlySurgeryRoomBlock: boolean) => {
    loadOperators(showOnlySurgeryRoomBlock);
  };

  const setLongDescription = (key: string) => {
    let longDescription = key.toUpperCase() + "_LONG_DESCRIPTION";
    return t(longDescription);
  };

  const controlDisabled = () => {
    let enabled = true;

    equipeList.map((element: any) => {
      if (element.inDate) {
        enabled = false;
      }
    });

    setEnableExit(enabled);
  };

  React.useEffect(() => {
    controlDisabled();
  }, [equipeList]);

  React.useEffect(() => {
    initPositionList();
    loadOperators(true);
    initData();
  }, []);

  React.useEffect(() => {
    if (shouldSaveData) {
      saveData();
    }
  }, [shouldSaveData]);

  return (
    <>
      <div className="page-container-margin">
        <div
          style={{ borderBottom: "1px solid #EEE" }}
          className="flex w-full justify-between items-center border-opacity-30 pb-4 text-right"
        >
          <Switch
            defaultChecked
            onChange={loadOffBlockUser}
            title="block"
            size="default"
            checkedChildren={t("EN_BLOC")}
            unCheckedChildren={t("OUT_OF_BLOCK")}
            className="equipe-switch"
            style={{
              backgroundColor: styles.hardBadgeLightBlueBg,
              color: "white",
              fontWeight: "bold",
            }}
            disabled={isDisabled}
          />
          <Space size={20}>
            <Button
              type="primary"
              style={{
                backgroundColor: styles.hardBadgeLightBlueBg,
                color: "white",
                fontWeight: "bold",
              }}
              icon={<PlayCircleFilled />}
              block
              onClick={() => applyMassiveDate(ActionDateType.IN)}
              disabled={isDisabled || equipeList.length === 0}
            >
              {t("ENTRANCE")}
            </Button>
            <Button
              type="primary"
              style={{
                backgroundColor: styles.hardBadgeLightBlueBg,
                color: "white",
                fontWeight: "bold",
              }}
              icon={<StopFilled />}
              block
              onClick={() => applyMassiveDate(ActionDateType.OUT)}
              disabled={enableExit || isDisabled}
            >
              {t("EXIT")}
            </Button>
          </Space>
        </div>
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-4 mt-2">
            <Select
              placeholder={t("MEDIC")}
              suffixIcon={
                <div className="text-teal-700 font-bold">
                  {t("SEARCH_ROLE")}{" "}
                  <UsergroupAddOutlined></UsergroupAddOutlined>
                </div>
              }
              style={{ width: "100%" }}
              disabled={isDisabled}
              onChange={(value) => {
                setSelectedRole(value);

                console.log(userRoles[value]);
              }}
            >
              {Object.keys(userRoles)
                .sort()
                .map((key) => (
                  <Select.Option key={key} value={key}>
                    {setLongDescription(key)}
                  </Select.Option>
                ))}
            </Select>
            {selectedRole && (
              <div className="mt-1">
                <Select
                  showSearch
                  placeholder={"Mario Rossi"}
                  suffixIcon={
                    <div className="text-teal-700 font-bold">
                      {t("SEARCH_OPERATOR")} <UserOutlined></UserOutlined>
                    </div>
                  }
                  style={{ width: "100%", marginTop: "1rem" }}
                  filterOption={(input, option) =>
                    (option?.children?.toString().toLowerCase() ?? "").includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    onSelectedUserChanged(
                      userRoles.hasOwnProperty(selectedRole)
                        ? userRoles[selectedRole].find(
                          (user) => (user?.operatoruuid || "") === value
                        )
                        : null
                    );
                  }}
                  disabled={isDisabled}
                >
                  {userRoles[selectedRole].map((user) => (
                    <Select.Option
                      key={user.operatoruuid}
                      value={user.operatoruuid}
                    >
                      {user.operatorDescription}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}
          </div>

          {/* LATO DESTRO OPERATORI IN INGRESSO / USCITA */}
          <div
            className="col-span-8"
            style={{
              borderLeft: "1px solid #EEE",
            }}
          >
            <div className="sisos-table-container">
              <Table
                dataSource={equipeList}
                className="sisos-table"
                size="small"
                pagination={{
                  pageSize: window.innerWidth > 800 ? 15 : 10,
                  hideOnSinglePage: false,
                  position: ["topCenter"],
                  size: "small",
                }}
                columns={[
                  {
                    title: t("USERNAME"),
                    dataIndex: "operatorDescription",
                    key: "operatorDescription",
                    render: (text, userEquipe) => (
                      <span>
                        {text || userEquipe.description}{" "}
                        <span className="text-sm">
                          ({userEquipe.operatorTypeInfo?.code || t("ND")})
                        </span>
                      </span>
                    ),
                  },
                  {
                    title: t("POSITION"),
                    dataIndex: "operatorPosition",
                    key: "operatorPosition",
                    render: (value, userEquipe, index) => (
                      <Select
                        className="w-full"
                        optionFilterProp="children"
                        fieldNames={{
                          label: "description",
                          value: "key",
                        }}
                        onChange={(value) => {
                          changePosition(value, userEquipe, index);
                        }}
                        filterOption={(input, option: any) =>
                          option.description
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={value}
                        options={positionList}
                        disabled={isDisabled}
                      />
                    ),
                  },
                  {
                    title: t("ENTRANCE"),
                    dataIndex: "inDate",
                    key: "inDate",
                    render: (value, userEquipe) => (
                      <TimePicker
                        className="w-full"
                        format="HH:mm:ss"
                        disabled={isDisabled}
                        onChange={(event) =>
                          setTeporalMarker(event, userEquipe, "in")
                        }
                        value={
                          value
                            ? DateTime.fromFormat(value, "yyyy-MM-dd HH:mm:ss")
                            : null
                        }
                        allowClear={{
                          clearIcon: (
                            <CloseCircleOutlined
                              onClick={() =>
                                setTeporalMarker(null, userEquipe, "in")
                              }
                            />
                          ),
                        }}
                      />
                    ),
                  },
                  {
                    title: t("EXIT"),
                    dataIndex: "outDate",
                    key: "outDate",
                    render: (value, userEquipe) => (
                      <TimePicker
                        className="w-full"
                        format="HH:mm:ss"
                        onChange={(event) =>
                          setTeporalMarker(event, userEquipe, "out")
                        }
                        value={
                          value
                            ? DateTime.fromFormat(value, "yyyy-MM-dd HH:mm:ss")
                            : null
                        }
                        disabled={isDisabled || !userEquipe.inDate}
                        allowClear={{
                          clearIcon: (
                            <CloseCircleOutlined
                              onClick={() =>
                                setTeporalMarker(null, userEquipe, "out")
                              }
                            />
                          ),
                        }}
                      />
                    ),
                  },
                  {
                    title: "",
                    key: "action",
                    render: (text, userEquipe) => (
                      <Button
                        type="primary"
                        disabled={isDisabled}
                        icon={<DeleteOutlined />}
                        style={{
                          backgroundColor: styles.red,
                          padding: "5px",
                        }}
                        className="customButtonNoFloat"
                        onClick={() => deleteEquipeUser(userEquipe)}
                      />
                    ),
                  },
                ]}
                rowKey="row"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Equipe;
